export default Object.freeze({
  RECORDED: 'recorded',
  UNRECORDED: 'unrecorded',
});
